import store from "../../../../store";
import sessionSocket from "../../../../socket/sessionSocket";
import roomAPIService from "../../roomAPIService";
import profileAPIService from "../../../../api/profileAPIService";
import { unmuteParticipant } from "./media";
import { pauseSound } from "./sound";
import { registerEnterTimestamp } from "./timestamps";

const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

export async function getSession(sessionID) {
  const user = AuthStore.user;

  try {
    if (!user || !user._id) throw new Error("no user");
    const result = await roomAPIService.getUpcomingSession(sessionID, user._id);
    /* console.log("@Room, getSession result: ", result); */

    /* Check if request was successful and that the session was retrieved */
    if (!result.success || !result.session) {
      throw new Error("request failed -- invalid params or smth");
    }
    const session = result.session;
    /* console.log("RESULT @room: ", result);
    console.log("@Room session: ", session);
    console.log("@Room session datetime:", session.dateTimeMS, typeof session.dateTimeMS); */
    if (result.isCompleted === false) {
      const dispatchObject = {
        dateTimeMS: session.dateTimeMS,
        SID: sessionID,
        partnerID: session.partner && session.partner.metadata ? session.partner.metadata.ID : null,
        partnerSessionData: session.partner && session.partner.session ? session.partner.session : null,
        currentSessionData: session.user && session.user.session ? session.user.session : null,
      };
      store.dispatch("upcomingMatches/setUpcomingMatch", dispatchObject);
    }

    const sessionData = {
      isCompleted: result.isCompleted,
      sessionID,
      dateTimeMS: session.dateTimeMS,
      partnerMetadata: session.partner && session.partner.metadata ? session.partner.metadata : null,
      sessionLoaded: true,
      ready: true,
    };

    if (result.session.sessionChat) {
      sessionData.sessionChat = result.session.sessionChat;
    }

    /* Dispatches are expensive, do it in one go whenever possible */
    await store.dispatch("session/setSessionData", sessionData);

    if (session.partner && session.partner.metadata && session.partner.metadata.ID) {
      /* Get and set partner session count */
      await getPartnerSessionCount(session.partner.metadata.ID);
    }

    /* Record participant's entering into the session */
    await registerEnterTimestamp();
  } catch (error) {
    console.error("@getSession error: ", error);
    store.commit("session/SET_SESSION_READY", false);
    // put up an error screen or smth
  }
}

export async function updateSessionPreferences() {
  try {
    const sessionPreferences = store.state.room.sessionPreferences;
    if (!sessionPreferences) throw new Error("Session preferences missing.");

    const user = AuthStore.user;
    if (!user || !user._id) throw new Error("no user");

    const result = await roomAPIService.updateSessionPreferences(sessionPreferences, user._id);
    /* console.log("@updateSessionPreferences result: ", result); */

    if (!result.success || !result.sessionPreferences) {
      throw new Error("request failed -- invalid params or smth");
    }
    /* console.log("@updateSessionPreferences: ", result.sessionPreferences); */
  } catch (error) {
    console.error("@updateSessionPreferences error: ", error);
  }
}

/**
 * Flow: session.js —> roomAPIService.js —> UsersRoutes.js —> UsersAPIController.js —> UserDataController.js
 */
export async function getSessionPreferences() {
  const user = AuthStore.user;

  try {
    if (!user || !user._id) throw new Error("no user");
    const result = await roomAPIService.getSessionPreferences(user._id);
    /* console.log("@getSessionPreferences result: ", result); */

    if (!result.success || !result.sessionPreferences) {
      throw new Error("request failed -- invalid params or smth");
    }
    const sessionPreferences = result.sessionPreferences;
    /* console.log("@getSessionPreferences: ", sessionPreferences); */

    store.commit("room/SET_SESSION_PREFERENCES", sessionPreferences);
  } catch (error) {
    console.error("@getSessionPreferences error: ", error);
  }
}

export async function getPartnerSessionCount(partnerID) {
  try {
    if (!partnerID) throw new Error("partner ID missing");
    const result = await profileAPIService.getPartnerSessionCount(partnerID);
    /* console.log("@getPartnerSessionCount result: ", result); */

    if (!result.success || (!result.sessionCount && result.sessionCount !== 0)) {
      throw new Error("request failed -- invalid params or smth");
    }
    const partnerSessionCount = result.sessionCount;
    /* console.log("@getPartnerSessionCount: ", partnerSessionCount); */

    store.commit("remoteProfileData/SET_PARTNER_SESSION_COUNT", partnerSessionCount);
  } catch (error) {
    console.error("@getPartnerSessionCount error: ", error);
  }
}

export async function confirmCompleteSession() {
  /* console.log("confirming session completion!"); */
  pauseSound();
  store.dispatch("session/setCompletionModalOpenState", false);
  store.dispatch("session/setSessionCompleteConfirmedState", true);

  /* This is implemented to fail-safe always unmute, even if sessionPreferences are not found */
  // if (store.state.room.sessionPreferences.unmuteWhenCompleteSession === false) {
  //   return;
  // }
  unmuteParticipant();
}

export async function toggleOwnState(state) {
  /**
   * state - (String) to identify state to toggle in object
   * property - (String) property of the state to toggle
   * value - (Boolean) value to set for property
   * icon - (Number) value to set to choose icon to use
   */
  const sessionID = store.state.session.sessionID;
  const value = store.state.mediastates.ownState[state].value;
  const data = {
    state,
    property: "value",
    value: !value,
    sessionID,
  };
  if (store.state.mediastates.ownState[state].supportState) {
    data.supportState = "";
  }
  store.dispatch("mediastates/setOwnState", data);
  sessionSocket.signalState(data);
}

export async function toggleOwnSupportState(state) {
  const sessionID = store.state.session.sessionID;
  const data = {
    supportState: state,
    sessionID,
  };
  store.dispatch("mediastates/setOwnSupportState", data);
  sessionSocket.signalSupportState(data);
}

export default {
  getSession,
  updateSessionPreferences,
  getSessionPreferences,
  getPartnerSessionCount,
};
